import * as API from './apiBase';

let baseList = {
    GetUserDefaultCompany: 'api/InvoiceNew/GetUserDefaultCompany',
    GetAgentList: 'api/InvoiceNew/GetAgentList',
    GetUserManual: 'api/InvoiceNew/GetUserManual',
    GetMenuList: 'api/Login/Authorize_Page'
}

/*获取头部公司数据 */
export const GetUserDefaultCompany = (username, BeAgentCode, language) => {
    return API.POST(baseList.GetUserDefaultCompany, {
        username,
        BeAgentCode,
        language
    })
};

/*被代理人（老板）列表 */
export const GetAgentList = (username, CompanyCode) => {
    return API.POST(baseList.GetAgentList, {
        username,
        CompanyCode
    })
};

/*用户手册 */
export const GetUserManual = () => {
    return API.POST(baseList.GetUserManual, {})
};

/*获取菜单 */
export const GetMenuList = (url) => {
    return API.POST(baseList.GetMenuList + url)
};
